<template>
  <section>
    <div v-for="purchase, index in order.purchases">
      <div class="row no-gutters">
        <div class="col-6">
          {{ purchase.service | multiLangName }}
          <span v-if="purchase.purchase_qty">
            ({{ $t('message.my_reservations.label_qty') }}: {{ purchase.purchase_qty | prettyNumber }})
          </span>
        </div>
        <div class="col-6 text-right">
          {{ purchase.total_price | currency }}
        </div>
      </div>
      <div class="row no-gutters mt-1">
        <div class="col-6">
          {{ $t('message.my_reservations.summary_total.service_vat') }}
        </div>
        <div class="col-6 text-right">
          {{ purchase.service_vat | currency }}
        </div>
      </div>
      <div class="row no-gutters mt-3">
        <div class="col-6">
          <label>{{ $t('message.my_reservations.summary_total.total') }}</label>
        </div>
        <div class="col-6 text-right">
          <label>{{ purchase.total_price_with_vat | currency }}</label>
        </div>
      </div>
      <div class="row no-gutters mt-1">
        <div class="col-12">
          <span v-html="$options.filters.orderPaymentData(purchase.payment_data)"></span>
          <span class="d-inline-block text-orange"
                v-if="!purchase.paid_status">
            ({{ $t('message.all_pending') }})
          </span>
        </div>
      </div>
      <div class="row no-gutters mt-1 text-secondary">
        <div class="col-6">
          {{ $t('message.my_reservations.created_at') }}
        </div>
        <div class="col-6 text-right">
          {{ purchase.created_at | prettyDate }}
        </div>
      </div>
      <div class="row no-gutters mt-1 text-secondary" v-if="purchase.paid_status && purchase.paid_at">
        <div class="col-6">
          {{ $t('message.my_reservations.paid_at') }}
        </div>
        <div class="col-6 text-right">
          {{ purchase.paid_at | prettyDate }}
        </div>
      </div>
      <hr v-if="order.purchases.length > 1 && (index + 1) < order.purchases.length">
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      order: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/OrderPurchase.vue